import { Component } from '@angular/core';
import {FormsModule, FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {UsersService} from "../../../_services/users.service";
import {NotificationService} from "../../../_services/notification.service";
import {ActivatedRoute, Router} from "@angular/router";
import {matchValidator, minLengthValidator, requiredValidator} from "../../../_util/validators";
import { HttpErrorResponse } from "@angular/common/http";
import {RouterLink} from "@angular/router";
import {LoaderDirective} from "../../../_directives/loader.directive";
import {SpriteVersionDirective} from "../../../_directives/spriteVersionDirective";
import {FormInputDirective} from "../../../_directives/formInput.directive";

@Component({
    selector: 'app-create-new-password',
    templateUrl: './create-new-password.component.html',
    styleUrls: ['../auth.scss', './create-new-password.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, RouterLink, LoaderDirective, SpriteVersionDirective, FormInputDirective]
})
export class CreateNewPasswordComponent {
  newPasswordForm: FormGroup = new FormGroup({
    newPassword: new FormControl('', [matchValidator('confirmPassword', true), minLengthValidator('PASSWORD'), requiredValidator()]),
    confirmPassword: new FormControl('', [matchValidator('newPassword'), minLengthValidator('PASSWORD'), requiredValidator()]),
  })
  isShowPassword: boolean = false
  isShowConfirmPassword: boolean = false
  verifyCode: string;
  showLoader = false;

  constructor(private userService: UsersService,
              private notifService: NotificationService,
              private route: ActivatedRoute,
              private router: Router) {
    this.verifyCode = this.route.snapshot.queryParamMap.get('verifyCode');
  }

  showPassword() {
    this.isShowPassword = !this.isShowPassword;
  }

  showConfirmPassword() {
    this.isShowConfirmPassword = !this.isShowConfirmPassword;
  }


  onSubmit() {
    if (this.newPasswordForm.invalid) return;
    this.showLoader = true;
    this.newPasswordForm.setErrors(null);

    this.userService.createNewPassword(this.verifyCode, this.newPasswordForm.get('confirmPassword')?.value).subscribe(() => {
      this.router.navigate(['/login']);
      this.notifService.successNotification("Password has been changed");
    }, (error: HttpErrorResponse) => {
      this.showLoader = false;
      if (error.status === 400){
        if (error.error.error === 'Bad code') this.newPasswordForm.setErrors({error: 'This password reset link is invalid or has already been used. Please request a new one.'});
        else if (error.error.error === 'Same password') this.newPasswordForm.setErrors({error: 'New password should be different from current one'});
      }
    });
  }
}
